export const CACHE_KEY_LIST_CLIENT_STRUCTURES = 'client-structures';
export const CACHE_KEY_CLIENT_STRUCTURES = 'client-structures-one';
export const ROUTE_PATH_CLIENT_STRUCTURES = '/clients/directory-list/structures';
export const TRANSLATION_PREFIX_CLIENT_STRUCTURES = 'clients';

